import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ShellComponent } from "./components/gs1-shell/shell/shell.component";
import { AppFooterComponent } from "./components/app-footer/app-footer.component";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  imports: [ShellComponent, AppFooterComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  standalone: true
})
export class AppComponent {

  constructor() { }

}
